import React, { Component } from 'react';
import moment from 'moment';
import DateBlock from "../../home/DateBlock"
import { Container, Row, Col, Form, Card, Spinner, ButtonGroup, Button } from 'react-bootstrap'
import { components } from 'react-select'
import SelectDropDown from '../../selectdropdown/SelectDropDown';
import gql from "graphql-tag";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import './_studentPerformanceReport.scss';
import ViewChapterWiseSummaryModal from "./viewChapterWiseSummaryModal";
import CardLessDataTableWithSearch from '../../datatables/CardLessDataTableWithSearch'
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import SubjectWiseReportCardModal from './subjectWiseReportCardModal';
import * as Cookies from "es-cookie";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";

const DropdownIndicator = (props) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <i className="fal fa-angle-down" />
            </components.DropdownIndicator>
        )
    );
};

const examTypes = [
    { value: 0, label: "All Exams" },
    { value: 1, label: "Mock Test" },
    { value: 2, label: "Custom Exam" },
    { value: 3, label: "Scheduled Exam" },
    { value: 4, label: "Error Exam" },
    // { value: 5, label: "Previous Year Paper" },
    { value: 6, label: "Practice Test" },
    { value: 7, label: "Adaptive Test" },
    // { value: 8, label: "Remedial Test" }
];


class StudentSummaryReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedExamValue: { value: 0, label: "All Exams" },
            startDateCalender: moment(new Date()).subtract(1, "month").startOf('day').unix(),
            endDateCalender: moment(new Date()).endOf('day').unix(),
            selectedChapter: [],
            loading: false,
            openModal: false,
            selectedViews: {
                examResult: 1,
                chapterPerformance: 1,
                accuracyAnalysis: 1,
                subjectPerformance: 1
            },
            examWiseResult: [],
            chapterPerformance: [],
            accuracyAnalysis: [],
            subjectPerformance: [],
            overallData: [],
            selectSubjectId: "",
            reportDownloadModal: false,
            reportSubjectDownloadModal: false,
            selectedSubjects: [],
        };
    }


    componentDidMount() {
        const { selectedExamValue, startDateCalender, endDateCalender } = this.state;
        this.getStudentExamReportChange(
            selectedExamValue?.value,
            startDateCalender,
            endDateCalender
        );
    };

    selecthandleInputChange = (name, value, selectedOption) => {
        this.setState({
            [name]: selectedOption,
            selectedViews: {
                examResult: 1,
                chapterPerformance: 1,
                accuracyAnalysis: 1,
                subjectPerformance: 1
            },

            searchValues: {
                examResult: "",
                chapterPerformance: "",
                accuracyAnalysis: "",
                subjectPerformance: ""
            },

            currentPages: {
                examResult: 1,
                chapterPerformance: 1,
                accuracyAnalysis: 1,
                subjectPerformance: 1
            },
            // startDateCalender: moment(new Date()).subtract(1, "month").startOf('day').unix(),
            // endDateCalender: moment(new Date()).startOf('day').unix(),
        }, () => {
            this.getStudentExamReportChange(
                selectedOption?.value,
                this.state.startDateCalender,
                this.state.endDateCalender
            );
        });
    };

    applyCallback = (startDate, endDate) => {
        const start = startDate.clone().startOf('day').unix();
        const end = endDate.clone().endOf('day').unix();

        this.setState({
            startDateCalender: start,
            endDateCalender: end,
        }, () => {
            this.getStudentExamReportChange(
                this.state.selectedExamValue?.value,
                start,
                end
            );
        });
    };

    getStudentExamReportChange = async (examType, from_date, to_date) => {

        const fromDateFinal = from_date || this.state.startDateCalender;
        const toDateFinal = to_date || this.state.endDateCalender;
        const examTypeFinal = examType ?? this.state.selectedExamValue?.value;

        this.setState({ loading: true });

        try {
            const result = await this.props.client.query({
                query: gql`
                         query ($mobile: String, $exam_type: Int, $fromDate: String, $toDate: String) {
                    getStudentExamOverview(
                        mobile: $mobile
                        exam_type: $exam_type
                        fromDate: $fromDate
                        toDate: $toDate
                    ) {
                        overall { 
                            exam_name
                            total_attempt_test
                            average_score
                            highest_score
                            lowest_score
                            section_avg_score
                            branch_avg_score
                            avg_rank
                            accuracy
                        }
                        examWiseResult {
                            id
                            exam_name
                            date
                            marks
                            exam_rank
                            accuracy
                            state_rank
                            branch_rank
                            city_rank
                            section_rank
                        }
                        subjectPerformance {
                            subject_id
                            subject
                            best_score
                            lowest_score
                            section_avg
                            branch_avg
                        }
                        chapterPerformance {
                            subject_id
                            subject
                            chapter_id
                            chapter
                            performance
                            performance_count
                            accuracy_percentage
                        }
                       accuracyAnalysis {
      difficulty
      correct
      wrong
      not_answered
      attempted
      correct_percentage
      wrong_percentage
    }
                    }
                }
                    `,
                variables: {
                    mobile: this.props?.mobile,
                    exam_type: examTypeFinal,
                    fromDate: fromDateFinal.toString(),
                    toDate: toDateFinal.toString(),
                },
                fetchPolicy: "network-only"
            });

            const data = result?.data?.getStudentExamOverview;

            this.setState({
                startDateCalender: Number(fromDateFinal),
                endDateCalender: Number(toDateFinal),
                overallData: data?.overall,
                examWiseResult: data?.examWiseResult || [],
                chapterPerformance: data?.chapterPerformance || [],
                accuracyAnalysis: data?.accuracyAnalysis || [],
                subjectPerformance: data?.subjectPerformance || [],
                loading: false,
            });

        } catch (error) {
            console.log(error);
            this.setState({ loading: false });
        }
    };

    handleViewChange = (key, value) => {
        this.setState(prev => ({
            selectedViews: {
                ...prev.selectedViews,
                [key]: value
            }
        }));
    };

    renderReportCard = (title, data, columns, graphOptions, key) => {

        const { selectedViews, chapterPerformance, selectSubjectId } = this.state;

        const uniqueSubjects = chapterPerformance.filter((value, index, self) => {
            return index === self.findIndex(obj => obj.subject_id === value.subject_id);
        });

        let filteredData = data;

        if (key === "chapterPerformance" && selectSubjectId) {
            filteredData = chapterPerformance.filter(
                item => item.subject_id == selectSubjectId
            );
        }

        return (

            <Card className="shadow-sm w-100"
                style={{ borderRadius: "12px", height: "100%" }}>

                <Card.Header
                    className="d-flex justify-content-between align-items-center"
                    style={{ background: "#fff" }}
                >
                    <h6 className="mb-0">{title}</h6>

                    <ButtonGroup>
                        {[
                            { value: 1, label: "Graph", icon: "fas fa-chart-bar" },
                            { value: 2, label: "Table", icon: "fas fa-table" }
                        ].map(btn => (
                            <Button
                                key={btn.value}
                                className={
                                    selectedViews[key] === btn.value
                                        ? "view-btn active-view-btn"
                                        : "view-btn"
                                }
                                onClick={() => this.handleViewChange(key, btn.value)}
                            >
                                <i className={btn.icon}></i>&nbsp;&nbsp;{btn.label}
                            </Button>
                        ))}
                    </ButtonGroup>

                </Card.Header>

                <Card.Body>
                    {key === "chapterPerformance" ? (
                        <div className="mb-3 mt-2 d-flex justify-content-end">
                            <select
                                className="form-control"
                                style={{ width: "200px" }}
                                value={selectSubjectId}
                                onChange={(e) =>
                                    this.setState({
                                        selectSubjectId: e.target.value
                                    })
                                }
                            >
                                <option value="">Select Subject</option>
                                {uniqueSubjects.map((item) => (
                                    <option
                                        key={item.subject_id}
                                        value={item.subject_id}
                                    >
                                        {item.subject}
                                    </option>
                                ))}
                            </select>
                        </div>
                    ) : key === "subjectPerformance" ? (
                        <div className='d-flex justify-content-end'>
                            <Button variant="primary" size='small' onClick={() => this.setState({
                                reportSubjectDownloadModal: true, selectedSubjects: data
                            })}>
                                Download <i className="fa fa-download" />
                            </Button>
                        </div>
                    ) : null}

                    {selectedViews[key] === 1 ? (
                        graphOptions ? (
                            <HighchartsReact
                                Highcharts={Highcharts}
                                options={graphOptions}
                            />
                        ) : (
                            <div className="text-center text-warning">
                                Graph data not available
                            </div>
                        )
                    ) : (
                        filteredData && filteredData.length > 0 ? (
                            <div className="sp-report-table">
                                <CardLessDataTableWithSearch
                                    parentData={filteredData}
                                    particlecolumns={columns}
                                    name="hostel_attendance"
                                />
                            </div>
                        ) : (
                            <div className="text-center text-danger">
                                No Data Found
                            </div>
                        )
                    )}
                </Card.Body>
            </Card>
        );
    };

    formatValue = (value) => {
        return value === null || value === undefined ? "-" : value;
    };

    accuracyColumns = [
        {
            dataField: "difficulty",
            text: "Difficulty",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "correct",
            text: "Correct",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "wrong",
            text: "Wrong",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "not_answered",
            text: "Not Answered",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "attempted",
            text: "Attempted",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "correct_percentage",
            text: "Correct %",
            sort: true,
            formatter: (cell) => `${cell}%`,
        },
        {
            dataField: "wrong_percentage",
            text: "Wrong %",
            sort: true,
            formatter: (cell) => `${cell}%`,
        }
    ];

    articlecolumns = [
        {
            dataField: "index",
            text: "#",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "exam_name",
            text: "Exam Name",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "total_attempt_test",
            text: "Total Attempt Test",
            sort: true,
            // Rendered as a pill to match the design. No drill-in handler exists
            // on this (college) page yet — wire onClick here if/when attempts view is added.
            formatter: (cell) =>
                (cell === null || cell === undefined || cell === "")
                    ? this.formatValue(cell)
                    : <span className="sp-attempt-pill">{cell}</span>,
        },
        {
            dataField: "average_score",
            text: "Average Score",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "highest_score",
            text: "Highest Score",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "lowest_score",
            text: "Lowest Score",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "section_avg_score",
            text: "Section Avg Score",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "branch_avg_score",
            text: "Branch Avg Score",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "avg_rank",
            text: "Average Rank",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "accuracy",
            text: "Accuracy",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
    ];

    examColumns = [
        {
            dataField: "index",
            text: "#",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "exam_name",
            text: "Exam Name",
            sort: true,
            formatter: this.examFunc.bind(this),
        },
        {
            dataField: "date",
            text: "Date",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "marks",
            text: "Marks",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "exam_rank",
            text: "Exam Rank",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "accuracy",
            text: "Accuracy",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "state_rank",
            text: "State Rank",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "branch_rank",
            text: "Branch Rank",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "city_rank",
            text: "City Rank",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "section_rank",
            text: "Section Rank",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "View",
            formatter: this.handleSessionFunction.bind(this),
            text: "View",
        },
        {
            dataField: "Download",
            formatter: this.handleDownloadFun.bind(this),
            text: "Download",
        },
    ];

    handleSessionFunction = (row) => {
        const exam_session_id = row?.id;
        const contact_no = this.props?.mobile;
        window.open(`https://devstudent1.rizee.in/student/subject/college-single-exam-result/:${exam_session_id}/:${contact_no}/:schedule_exam`, "_blank")
    };

    handleSessionFunction(val, row) {
        return (
            <div className="actions-buttons d-flex justify-content-center align-items-top" >
                <Button variant="link" name="view" className="text-theme" onClick={() => this.handleSessionFunction(row)}>
                    <i className="fas fa-eye" />
                </Button>
            </div>
        )
    };

    handleDownloadFun(val, row) {
        return (
            <div className="actions-buttons d-flex justify-content-center align-items-top" >
                <Button variant="link" name="view" className="text-theme" onClick={() => this.setState({
                    reportDownloadModal: true, selectedChapter: [row]
                })}>
                    <i className="fa fa-download" />
                </Button>
            </div>
        )
    };

    chapterColumns = [
        {
            dataField: "index",
            text: "#",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "subject",
            text: "Subject",
            sort: true,
            align: 'center',
            headerClasses: 'text-center',
        },
        {
            dataField: "chapter",
            text: "Chapter",
            sort: true,
        },
        {
            dataField: "performance",
            text: "Performance",
            sort: true,
            formatter: this.performanceFunc.bind(this),
        },
        {
            dataField: "accuracy_percentage",
            text: "Accuracy %",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
    ];

    subjectColumns = [
        {
            dataField: "index",
            text: "#",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "subject",
            text: "Subject",
            sort: true,
            align: 'center',
            headerClasses: 'text-center',
        },
        {
            dataField: "best_score",
            text: "Best Score",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "lowest_score",
            text: "Lowest Score",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "branch_avg",
            text: "Branch Avg",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
        {
            dataField: "section_avg",
            text: "Section Avg",
            sort: true,
            formatter: (cell) => this.formatValue(cell),
        },
    ];

    examFunc(cell, row) {
        return (
            <span style={{ color: "#0d6efd", textDecoration: row.exam_name ? "underline" : "", cursor: "pointer" }} onClick={() => this.setState({ openModal: true, selectedChapter: [row] })}>
                {row.exam_name ?? "-"}
            </span>
        );
    };

    performanceFunc(cell, row) {
        const performanceColors = {
            strong: "#28a745",   // green
            average: "#ffc107",  // yellow
            weak: "#dc3545"      // red
        };

        const performanceIcons = {
            strong: "fa fa-star",        // ⭐ strong
            average: "fa fa-adjust",     // ⚖️ average
            weak: "fa fa-times-circle"  // ❌ weak
        };

        const value = (row.performance || "").toLowerCase();

        const color = performanceColors[value] || "#6c757d"; // default gray
        const icon = performanceIcons[value] || "fa fa-circle";

        return (
            <span
                style={{
                    color: color,
                    textDecoration: "underline",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px"
                }}
            >
                <i className={icon}></i>
                {row.performance ?? "-"}
            </span>
        );
    };

    render() {

        const { selectSubjectId,
            selectedExamValue,
            examWiseResult,
            chapterPerformance,
            accuracyAnalysis,
            subjectPerformance,
            loading,
            overallData, } = this.state;

        const examWiseResultGraph = {
            chart: {
                type: "column",
                backgroundColor: "#f5f7fa",
                borderRadius: 10,
                spacingLeft: 20,
                scrollablePlotArea: {
                    minWidth: examWiseResult?.length > 8 ? examWiseResult.length * 100 : null,
                    scrollPositionX: 0
                }
            },
            title: {
                text: ""
            },
            xAxis: {
                categories: examWiseResult.map(i => i.exam_name),
                labels: {
                    // rotation: -45,
                    style: {
                        fontWeight: "600"
                    }
                }
            },

            yAxis: [
                {
                    title: {
                        text: "Marks / Accuracy"
                    }
                },
                {
                    title: {
                        text: "Ranks"
                    },
                    opposite: true,
                    reversed: false
                }
            ],

            credits: { enabled: false },

            plotOptions: {
                column: {
                    grouping: true,
                    borderRadius: 5,
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontSize: "9px"
                        }
                    }
                }
            },

            series: [
                // 🔵 MARKS (Pictograph blocks)
                {
                    name: "Marks",
                    data: examWiseResult.map(i => i.marks || 0),
                    color: "#1f4e79",
                    yAxis: 0,
                    type: "line",
                },
                // 🟢 ACCURACY
                {
                    name: "Accuracy (%)",
                    data: examWiseResult.map(i => i.accuracy || 0),
                    color: "#2ecc71",
                    yAxis: 0,
                    type: "line"
                },
                // 🔴 RANKS (Secondary Axis)
                {
                    name: "Exam Rank",
                    data: examWiseResult.map(i => i.exam_rank || 0),
                    color: "#e74c3c",
                    yAxis: 1,
                },
                {
                    name: "State Rank",
                    data: examWiseResult.map(i => i.state_rank || 0),
                    color: "#8e44ad",
                    yAxis: 1
                },
                {
                    name: "Branch Rank",
                    data: examWiseResult.map(i => i.branch_rank || 0),
                    color: "#f39c12",
                    yAxis: 1
                },
                {
                    name: "City Rank",
                    data: examWiseResult.map(i => i.city_rank || 0),
                    color: "#16a085",
                    yAxis: 1
                },
                {
                    name: "Section Rank",
                    data: examWiseResult.map(i => i.section_rank || 0),
                    color: "#34495e",
                    yAxis: 1
                }
            ],
            legend: {
                align: "center",
                verticalAlign: "bottom"
            },
            exporting: {
                enabled: true
            }
        };

        const accuracyAnalysisGraph = {
            chart: {
                type: "column"
            },

            title: {
                text: ""
            },
            xAxis: {
                categories: accuracyAnalysis.map(item => item.difficulty),
                title: {
                    text: "Difficulty Level"
                }
            },
            yAxis: {
                min: 0,
                title: {
                    text: "Count"
                }
            },
            credits: {
                enabled: false
            },

            tooltip: {
                shared: false
            },

            plotOptions: {
                column: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [
                {
                    name: "Correct",
                    data: accuracyAnalysis.map(item => ({
                        y: item.correct,
                        color: "#00e272"
                    }))
                },
                {
                    name: "Wrong",
                    data: accuracyAnalysis.map(item => ({
                        y: item.wrong,
                        color: "#f97316"
                    }))
                },
                {
                    name: "Not Answered",
                    data: accuracyAnalysis.map(item => ({
                        y: item.not_answered,
                        color: "#94a3b8"
                    }))
                },
                {
                    name: "Attempted",
                    data: accuracyAnalysis.map(item => ({
                        y: item.attempted,
                        color: "#3b82f6"
                    }))
                },
                {
                    name: "correct %",
                    data: accuracyAnalysis.map(item => ({
                        y: item.correct_percentage,
                        color: "green"
                    })),
                    type: "line"
                },
                {
                    name: "wrong %",
                    data: accuracyAnalysis.map(item => ({
                        y: item.wrong_percentage,
                        color: "blue"
                    })),
                    type: "line"
                }
            ]
        };


        const subjectPerformanceGraph = {
            chart: {
                type: "bar",
                backgroundColor: "#f5f7fa",
                borderRadius: 10,
                spacingLeft: 20,
                scrollablePlotArea: {
                    minWidth: subjectPerformance?.length > 10 ? subjectPerformance?.length * 80 : null,
                    scrollPositionX: 0
                }
            },

            title: {
                text: ""
            },

            xAxis: {
                categories: subjectPerformance?.map((item) => item.subject),
                scrollbar: {
                    enabled: true
                },
                labels: {
                    // rotation: -45,
                    style: {
                        fontWeight: "600",
                        color: "#000"
                    }
                }
            },

            yAxis: {
                title: {
                    text: "Score"
                },
                tickInterval: 5
            },

            credits: {
                enabled: false
            },

            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                },
                series: {
                    borderRadius: 6,   // ✅ main change
                    pointPadding: 0.1,
                    groupPadding: 0.2
                }
            },

            legend: {
                layout: 'vertical',
                align: 'right',
                verticalAlign: 'top',
                x: -40,
                y: 80,
            },

            series: [
                {
                    name: "Best Score",
                    data: subjectPerformance.map(i => i.best_score || 0),
                    color: "#1f4e79"
                },
                {
                    name: "Lowest Score",
                    data: subjectPerformance.map(i => i.lowest_score || 0),
                    color: "#2ecc71"
                },
                {
                    name: "Branch Avg",
                    data: subjectPerformance.map(i => i.branch_avg || 0),
                    color: "#007bff"
                },
                {
                    name: "Section Avg",
                    data: subjectPerformance.map(i => i.section_avg || 0),
                    color: "#e74c3c"
                }
            ],

            exporting: {
                enabled: true
            }
        };

        const subjectWiseChapterData = !selectSubjectId
            ? chapterPerformance
            : chapterPerformance.filter(
                item => item.subject_id === Number(selectSubjectId)
            );

        const chapterGraphOptions = {
            chart: {
                backgroundColor: "#f5f7fa",
                borderRadius: 10,
                spacingLeft: 20,
                scrollablePlotArea: {
                    minWidth: Math.max(subjectWiseChapterData.length * 80, 800),
                    scrollPositionX: 0
                }
            },

            title: {
                text: ""
            },

            xAxis: {
                categories: subjectWiseChapterData.map(c => c.chapter),
                title: { text: "Chapters" },
                scrollbar: {
                    enabled: true
                },
                labels: {
                    // rotation: -45,
                    style: {
                        fontWeight: "600",
                        color: "#000"
                    }
                }
            },
            yAxis: [
                {
                    title: { text: "Performance Count" }, // 🔵 left axis
                },
                {
                    title: { text: "Accuracy (%)" }, // 🟢 right axis
                    max: 100,
                    opposite: true
                }
            ],
            series: [
                {
                    name: "Performance",
                    data: subjectWiseChapterData.map(c => Number(c.performance_count || 0)),
                    type: "column",
                    color: "#007bff",
                    yAxis: 0
                },
                {
                    name: "Accuracy (%)",
                    data: subjectWiseChapterData.map(c => Number(c.accuracy_percentage || 0)),
                    type: "line",
                    color: "#28a745",
                    yAxis: 1
                }
            ],

            plotOptions: {
                column: {
                    dataLabels: {
                        enabled: true
                    }
                },
                line: {
                    dataLabels: {
                        enabled: true,
                        format: "{y}%"
                    },
                    marker: {
                        enabled: true,
                        radius: 4
                    }
                }
            },

            exporting: { enabled: true },
            credits: { enabled: false }
        };


        const getOrganisationProfile = this.props.getOrganisationProfile;
        const loading3 = getOrganisationProfile.loading;
        const error3 = getOrganisationProfile.error;

        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }

        let orgname = "INSTITUTION NAME";
        let logo = "";

        if (this.props.getOrganisationProfile.getOrganisationProfile != null) {
            orgname = getOrganisationProfile.getOrganisationProfile.organisation_name;
            logo = getOrganisationProfile.getOrganisationProfile.logo;
        }

        return (
            <Container fluid>
                <Row className="justify-content-end mt-2 h-100">
                    {[
                        { id: 1, label: "Exam", name: "selectedExamValue", value: selectedExamValue, options: examTypes },
                        { id: 2, label: "Date" },
                    ].map(field => (

                        <Col xl={3} lg={3} md={4} sm={12} key={field.id}>
                            <Form.Group as={Row} className="align-items-center">

                                <Form.Label column sm={2} className="fw-bold">
                                    {field.label}
                                </Form.Label>

                                <Col sm={10}>
                                    {
                                        field.id === 2 ? (
                                            <>
                                                <Form.Group className="customDate mb-0 mr-5" controlId="StartDate" style={{ width: "150px" }}>
                                                    <DateBlock
                                                        applyCallback={this.applyCallback}
                                                        start={moment.unix(this.state.startDateCalender)}
                                                        end={moment.unix(this.state.endDateCalender)}
                                                    />
                                                </Form.Group>
                                            </>
                                        ) : (
                                            <SelectDropDown
                                                stateData={field.value}
                                                handleChange={this.selecthandleInputChange}
                                                name={field.name}
                                                options={field.options}
                                                placeholderName={field.label}
                                                dropdownIndicator={{ DropdownIndicator }}
                                            />
                                        )
                                    }
                                </Col>
                            </Form.Group>
                        </Col>
                    ))
                    }
                </Row>

                {
                    loading ? (
                        <Row className="justify-content-center mt-5" style={{ height: loading ? "600px" : "" }}>
                            <Col md={2} className="text-center">
                                <Spinner animation="border" role="status" />
                                <div className="mt-2 fw-bold">Loading Report...</div>
                            </Col>
                        </Row>
                    ) : (
                        <>
                            <Row>
                                <Col sm={12}>
                                    <CardLessDataTableWithSearch
                                        parentData={overallData}
                                        particlecolumns={this.articlecolumns}
                                        name="hostel_attendance"
                                    />
                                </Col>
                            </Row>

                            <Row className="g-3">
                                <Col sm={12} className='mt-2'>
                                    {this.renderReportCard(
                                        "Exam Wise Results",
                                        examWiseResult,
                                        this.examColumns,
                                        examWiseResultGraph,
                                        "examResult"
                                    )}
                                </Col>

                                <Col sm={6} className='mt-2'>
                                    {this.renderReportCard(
                                        "Subject Performance",
                                        subjectPerformance,
                                        this.subjectColumns,
                                        subjectPerformanceGraph,
                                        "subjectPerformance"
                                    )}
                                </Col>

                                <Col sm={6} className='mt-3'>
                                    {this.renderReportCard(
                                        "Accuracy Analysis",
                                        accuracyAnalysis,
                                        this.accuracyColumns,
                                        accuracyAnalysisGraph,
                                        "accuracyAnalysis"
                                    )}
                                </Col>

                                <Col sm={12} className='mt-2'>
                                    {this.renderReportCard(
                                        "Chapter Performance",
                                        chapterPerformance,
                                        this.chapterColumns,
                                        chapterGraphOptions,
                                        "chapterPerformance"
                                    )}
                                </Col>
                            </Row>
                        </>
                    )
                }


                {
                    this.state.openModal === true ? (
                        <ViewChapterWiseSummaryModal
                            stateData={this.state.selectedChapter}
                            show={this.state.openModal}
                            onHide={() => this.setState({ openModal: false })}
                            propsData={this.props}
                            type="view"
                            globalData={this.props.propsData}
                            orgname={orgname}
                            logo={logo}
                        />
                    ) : this.state.reportDownloadModal === true ? (
                        <ViewChapterWiseSummaryModal
                            stateData={this.state.selectedChapter}
                            show={this.state.reportDownloadModal}
                            onHide={() => this.setState({ reportDownloadModal: false })}
                            propsData={this.props}
                            type="report"
                            studentData={this.props.stateData.studentData}
                            globalData={this.props.propsData}
                            orgname={orgname}
                            logo={logo}
                        />
                    ) : null
                }


                {
                    this.state.reportSubjectDownloadModal === true ? (
                        <SubjectWiseReportCardModal
                            stateData={this.state.selectedSubjects}
                            show={this.state.reportSubjectDownloadModal}
                            onHide={() => this.setState({ reportSubjectDownloadModal: false })}
                            propsData={this.props}
                            type="subjectReport"
                            studentData={this.props.stateData.studentData}
                            globalData={this.props.propsData}
                            orgname={orgname}
                            logo={logo}
                            subjectPerformanceData={subjectPerformance}
                        />
                    ) : null
                }
            </Container>
        );
    }
}
export default compose(
    withApollo,
    withRouter,

    graphql(gql`
    query ($institution_id: Int!) {
      getOrganisationProfile(institution_id: $institution_id) {
        id
        organisation_name
        logo
      }
    }
  `, {
        options: (props) => ({
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
            },
        }),
        name: "getOrganisationProfile",
    })

)(StudentSummaryReports);